import { Button, Space, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useCallback, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import AddIcon from "../../../assets/icons/AddIcon";
import CloseIcon from "../../../assets/icons/CloseIcon";
import LeftArrowIcon from "../../../assets/icons/LeftArrowIcon";
import LinkIcon from "../../../assets/icons/LinkIcon";
import QuestionIcon from "../../../assets/icons/QuestionIcon";
import CustomTable from "../../../components/common/CustomTable";
import InputFileNormal from "../../../components/common/InputFileNormal";
import Loader from "../../../components/common/Loader";
import AddTaskModal from "../../../components/NP/Payment/AddTaskModal";
import CreateBatchPaymentModal from "../../../components/NP/Payment/CreateBatchPaymentModal";
import { IMAGE_URL } from "../../../helpers/config";
import { addKeyInArray } from "../../../helpers/siteConfig";
import useModal from "../../../hooks/useModal";
import useTable from "../../../hooks/useTable";
import AdminLayout from "../../../layouts/AdminLayout";
import {
  getSingleBatchmentPaymentAsync,
  updateBatchPaymentAsync,
} from "../../../store/features/NP/supplier/supplierAPI";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import { capitalize } from "../../../utils/string";
import NotfoundTableData from "./NotfoundTableData";

export default function BatchTaskList() {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const { page, handlePagination, limit } = useTable();
  const [vatUrl, setVatUrl] = useState<string | null>("");
  // const [selectedData, setSelectedData] = useState<string[]>([]);
  const { open, handleOpen, toggle } = useModal(reRender);
  const { viewLoading, getSingleBatchmentPayment, postLoading } =
    useAppSelector((state) => state.supplier);
  const navigate = useNavigate();

  const columns: ColumnsType<any> = [
    {
      title: "Zone",
      dataIndex: "areaName",
      align: "center",
      render: (val) => (val ? capitalize(val) : "N/A"),
    },
    {
      title: "Cluster",
      dataIndex: "regionName",
      align: "center",
      render: (val) => (val ? capitalize(val) : "N/A"),
    },
    {
      title: "Site ID",
      dataIndex: "siteCode",
      align: "center",
      render: (val) => val || "N/A",
    },
    {
      title: "Tower",
      dataIndex: "tower",
      align: "center",
      render: (val) => capitalize(val?.towerName) || "N/A",
    },
    {
      title: "PG Name",
      dataIndex: "pg",
      align: "center",
      render: (val) =>
        `${val?.firstName} ${val?.lastName ? val?.lastName : ""}`,
    },
    {
      title: "Missed Call",
      dataIndex: "missCall",
      align: "center",
      render: (val) => (val ? "Yes" : "No"),
    },
    {
      title: "Base Amount",
      dataIndex: "totalAmount",
      align: "center",
      render: (val) => (val ? val : 0),
    },
    {
      title: "PGRH",
      dataIndex: "totalValidRunTime",
      align: "center",
      render: (val) => (val ? val : "N/A"),
    },
    // {
    //   title: "PGRH Rate",
    //   dataIndex: "zone",
    //   align: "center",
    //   render: (val) => (val ? val : "N/A"),
    // },
  ];

  const updateVat = () => {
    if (vatUrl)
      dispatch(
        updateBatchPaymentAsync({
          data: {
            vat: vatUrl,
          },
          others: {
            id,
            message: "Vat added successfully",
            reRender: () => {
              navigate("/vendor/payment/batch-payment");
            },
          },
        })
      );
  };

  const getData = useCallback(() => {
    if (id) dispatch(getSingleBatchmentPaymentAsync({ params: { id: id } }));
  }, [dispatch, id]);

  useEffect(() => {
    getData();
  }, [getData]);

  function reRender() {
    getData();
    setVatUrl("");
  }

  const batchList = getSingleBatchmentPayment?.towerTicketLogArray;

  const header = (
    <div className="flex justify-between items-center gap-4 flex-wrap p-5 bg-[#F3FAFF]">
      <h6 className="text-lg font-medium">
        <span className="text-primary-sa">Batch Name:</span>{" "}
        {/* <span className="text-primary-sa">Natch Bane:</span>{" "} */}
        {getSingleBatchmentPayment?.batchName || ""}
      </h6>
      <h6 className="text-lg font-medium">
        <span className="text-primary-sa">Invoice ID: </span>{" "}
        {getSingleBatchmentPayment?.batchCode || ""}
      </h6>
      <Link to="/vendor/payment/batch-payment">
        <Button
          className="!border-others-header !text-sm !font-normal !rounded-lg !border !text-header !bg-transparent"
          size="large"
          icon={<LeftArrowIcon />}
        >
          <span>Back</span>
        </Button>
      </Link>
    </div>
  );

  const vat_url = vatUrl || getSingleBatchmentPayment?.vat;

  return (
    <AdminLayout title="Batch" headerTitle="Batch">
      {(open?.type === "ADD" || open?.type === "UPDATE") && (
        <AddTaskModal
          open={open?.open}
          handleClose={toggle}
          data={open?.data}
        />
      )}
      {open?.type === "EDIT_BATCH_PAYMENT" && (
        <CreateBatchPaymentModal open={open?.open} handleClose={toggle} />
      )}

      {viewLoading ? (
        <Loader />
      ) : batchList?.length ? (
        <CustomTable
          loading={!!viewLoading}
          total={batchList?.length}
          page={page}
          limit={limit}
          handlePagination={handlePagination}
          columns={columns}
          dataList={addKeyInArray(batchList)}
          // rowSelection={{
          //   type: "checkbox",
          //   selectedRowKeys: selectedData,
          //   onChange: (key) => {
          //     setSelectedData(key as string[]);
          //   },
          //   // getCheckboxProps: (record) => {
          //   //   return {
          //   //     disabled: record?.status === "invited",
          //   //   };
          //   // },
          //   columnWidth: 40,
          // }}
          topOfTheTableComponent={header}
          underThePaginationComponent={
            <div className="p-4 border-t border-solid border-x-0 border-b-0 border-t-gray-400 mt-2.5 flex items-center gap-6 flex-wrap">
              {vat_url ? (
                <a
                  href={IMAGE_URL + vat_url}
                  target="_blank"
                  className="text-[#1B4DFF] underline cursor-pointer font-medium"
                  rel="noreferrer"
                >
                  {(() => {
                    const maxStart = 15;

                    const lastDotIndex = vat_url.lastIndexOf(".");
                    const extension =
                      lastDotIndex !== -1 ? vat_url.slice(lastDotIndex) : "";
                    const base = vat_url.slice(0, maxStart);

                    return `${base}...${extension}`;
                  })()}
                </a>
              ) : null}

              <InputFileNormal
                accept=".pdf,.jpg,.jpeg,.png"
                onChange={(url) => {
                  url && setVatUrl(url as string | null);
                }}
                btnComponent={(isLoading) => (
                  <Button
                    className="!text-[#33AB29] !border-[#33AB29] !h-10 flex items-center"
                    icon={<LinkIcon />}
                    size="middle"
                    loading={isLoading}
                  >
                    Add VAT 6.3
                  </Button>
                )}
              />

              <Tooltip
                title="Before submit, please add a vat file"
                placement="top"
              >
                <div className="relative top-0.5 -left-2">
                  <QuestionIcon />
                </div>
              </Tooltip>
            </div>
          }
        />
      ) : (
        <div>
          {header}
          <div className="flex justify-center items-center min-h-[400px]">
            <NotfoundTableData />
          </div>
        </div>
      )}

      <div className="flex justify-between items-center mt-6 flex-wrap gap-6">
        <Link to="/vendor/payment/batch-payment">
          <Button
            className="!border-others-header !text-header"
            size="large"
            icon={<CloseIcon />}
          >
            <span>Close</span>
          </Button>
        </Link>

        <Space size="middle">
          {/* <Button
            onClick={() => handleOpen({ type: "EDIT_BATCH_PAYMENT" })}
            size="large"
            icon={<EditIcon />}
          >
            Edit Batch
          </Button> */}

          {/* {!!selectedData?.length && (
            <Button
              onClick={() => handleOpen({ type: "DELETE" })}
              className="!bg-status-danger-text !text-white hover:bg-status-danger-text hover:text-white border-0 hover:border-0"
              size="large"
              icon={<AddIcon />}
            >
              Remove
            </Button>
          )} */}
          {!!batchList?.length && (
            <Button
              onClick={() => handleOpen({ type: "UPDATE", data: batchList })}
              className="!bg-[#2D3643] !text-white hover:bg-[#2D3643] hover:text-white border-0 hover:border-0"
              size="large"
              icon={<AddIcon />}
            >
              Add More Task
            </Button>
          )}

          {!batchList?.length && (
            <Button
              onClick={() => handleOpen({ type: "ADD" })}
              type="primary"
              size="large"
              icon={<AddIcon />}
            >
              Add Task
            </Button>
          )}
          {!!vatUrl && (
            <Button
              type="primary"
              size="large"
              icon={<AddIcon />}
              loading={postLoading}
              onClick={updateVat}
            >
              Submit
            </Button>
          )}
        </Space>
      </div>
    </AdminLayout>
  );
}
